import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { camelCaseToWords } from 'utils/string';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  product?: string;
}

export const Product: FC<OwnProps> = ({ product }) => {
  const { formatMessage } = useIntl();
  const { isLoading } = useContext(AddonMainFormContext);

  const translateProduct = useCallback(
    (p: string | undefined) =>
      p !== undefined
        ? formatMessage({
            id: `field.${p}` as any,
            defaultMessage: camelCaseToWords(p),
          })
        : '',
    [formatMessage],
  );

  return (
    <BlockOrientationFormGroup inputId="product" label="addon.product">
      {(!isLoading || product !== undefined) && <TextField id="product" value={translateProduct(product)} isReadOnly />}
      {isLoading && product === undefined && <TextFieldSkeleton />}
    </BlockOrientationFormGroup>
  );
};

Product.displayName = 'Product';
